import React, { useEffect, useRef } from 'react';
import { cx } from '../../../utils/cx.js';
import nl2br from '../../../utils/nl2br';

import { translate } from '../../../utils/wp';

import { Fish, Steak, Veg } from '../../icons';

import { NumberSelector } from '../../NumberSelector';

function getMenuMarkup(menu) {
    return {
        __html: nl2br(
            menu +
            '\n\n<span class="allergy-notice">' +
            translate('food_allergy') +
            '</span>',
        ),
    };
}

function FoodItem({
    value,
    type,
    min,
    max,
    menu,
    expanded,
    small,
    disabled,
    onToggle,
    onChange,
    titles,
}) {
    const ref = useRef(null);

    const types = {
        0: {
            icon: <Steak />,
            text: titles.meat,
        },
        1: {
            icon: <Fish />,
            text: titles.fish,
        },
        2: {
            icon: <Veg />,
            text: titles.veg,
        },
    };

    useEffect(() => {
        if (expanded && ref.current) {
            ref.current.scrollIntoView({
                behavior: 'smooth',
            });
        }
    }, [expanded]);

    return (
        <div
            className="food-item border border-primary p-4 rounded"
            ref={ref}
        >
            <div className="food-item__select flex items-center justify-between">
                <div className="food-item__type flex items-center gap-x-2 text-sm font-bold">
                    {types[type].icon}
                    {types[type].text}
                </div>
                <NumberSelector
                    disabled={disabled}
                    value={value}
                    suffix="st"
                    min={min}
                    max={max}
                    onChange={(value) => onChange(
                        value,
                        type,
                        types[type].text,
                    )}
                    className="number-selector"
                />
            </div>
            {menu?.length > 0 ? (
                <button
                    className="button food-item__show-menu w-full bg-primary text-primarytext font-semibold mt-2.5 rounded px-4 py-2.5"
                    onClick={() => onToggle(type)}
                >
                    {!expanded ? translate('food_show_menu') : translate(
                        'food_hide_menu')}
                </button>
            ) : (
                <button className="button food-item__show-menu pointer-events-none w-full bg-disabled text-primarytext/50 font-semibold mt-2.5 rounded px-4 py-2.5">
                    {translate('food_show_menu')}
                </button>
            )}
            <div
                className={cx(
                    'food-item__menu pt-4',
                    expanded ? 'block' : 'hidden',
                )}
                dangerouslySetInnerHTML={getMenuMarkup(menu)}
            />
        </div>
    );
}

function FoodItemMeat(props) {
    return (
        <FoodItem
            {...props}
            type={0}
        />
    );
}

function FoodItemFish(props) {
    return (
        <FoodItem
            {...props}
            type={1}
        />
    );
}

function FoodItemVeg(props) {
    return (
        <FoodItem
            {...props}
            type={2}
        />
    );
}

export { FoodItemMeat, FoodItemFish, FoodItemVeg };
